import { createAction } from '@reduxjs/toolkit';
import { createAsyncAction } from 'services/actionConfigs';
import { IApiGetDemoDataParam, IApiGetListScreensInStoreParam, IApiGetListStoresParam, ICreateStoreRequest, ITimezone } from '../interfaces/api';
import { PREFIX_ACTIONS } from './constants';

const getDemoData = createAsyncAction<IApiGetDemoDataParam>(PREFIX_ACTIONS + 'getDemoData');
const createStore = createAsyncAction<ICreateStoreRequest>(PREFIX_ACTIONS + 'createStore');
const getListStores = createAsyncAction<IApiGetListStoresParam>(PREFIX_ACTIONS + 'getListStores');
const setListStoresParams = createAction<IApiGetListStoresParam>(PREFIX_ACTIONS + 'setListStoresParams');
const getListScreensInStore = createAsyncAction<IApiGetListScreensInStoreParam>(PREFIX_ACTIONS + 'getListScreensInStore');
const getListTimezones = createAsyncAction<void, ITimezone[]>(PREFIX_ACTIONS + 'getListTimezones');
const getAllStores = createAsyncAction<void>(PREFIX_ACTIONS + 'getAllStores');
const getDetailStore = createAsyncAction<string>(PREFIX_ACTIONS + 'getDetailStore');
const getListPlaylistsInStore = createAsyncAction<IApiGetListScreensInStoreParam>(PREFIX_ACTIONS + 'getListPlaylistsInStore');

const storeActions = {
  getDemoData,
  createStore,
  getListStores,
  setListStoresParams,
  getListScreensInStore,
  getListTimezones,
  getAllStores,
  getDetailStore,
  getListPlaylistsInStore,
};

export default storeActions;

